// Imports
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import APIButton, { APIButtonOptions } from '../../../../../../shareables/integrations/api/components/button';
import RenamableTableCell from '../../../../../../shareables/integrations/api/components/tables/renamable-table-cell';
import { GetMyPhotosResponse } from '../../../../../../shareables/types/api/main/website/page/type/206/my-photos/get';


// Styled components
const Thumbnail = styled.td`
	max-width: 12rem;
	overflow: hidden;
	
	img {
		max-height: 9.375rem;
		max-width: 12rem;
		display: block;
	}
`;


// Define the accepted props
interface Props {
	photo: GetMyPhotosResponse[0];
	pageID: number;
	onChange: () => void;
	index: number;
}


// Function component
const PhotoGalleryRow: React.FC<Props> = ({ photo, pageID, onChange, index }) => {
	// Build button options
	let warningModalCaption = photo.caption?.slice(0, 24);
	
	if (photo.caption && warningModalCaption && photo.caption.length !== warningModalCaption.length) {
		warningModalCaption = `${warningModalCaption}…`;
	}
	
	const buttonOptions: APIButtonOptions<undefined, undefined, undefined> = {
		action: 'DELETE',
		uri: `/website/${window.location.hostname}/page/id_${pageID}/type/206/my-photo/${photo.id}`,
		tooltip: 'Delete this photo',
		warning: {
			message: 'Deleting this photo is permanent.',
			button: `Yes, delete ${warningModalCaption ? `the “${warningModalCaption}”` : 'this'} photo`,
		},
	};
	
	
	// Return JSX
	return (
		<tr>
			<Thumbnail>
				{/* Caption is shown as visible text in the next cell, so avoid repeating it here for screen readers */}
				<img src={photo.thumbnail} alt={photo.caption ? '' : `Photo ${index + 1}`} />
			</Thumbnail>
			
			<RenamableTableCell
				name='caption'
				initialValue={photo.caption ?? ''}
				action='RECAPTION'
				uri={`/website/${window.location.hostname}/page/id_${pageID}/type/206/my-photo/${photo.id}`}
				onCompletion={onChange}
				maxLength={150}
				required={false}
				fallbackText={<em>No caption</em>}
			/>
			
			<td style={{ textAlign: 'center' }}>
				<APIButton
					options={buttonOptions}
					color='danger'
					aria-label='Delete this photo'
					onCompletion={onChange}
					smaller
				>
					<FontAwesomeIcon icon={faTrash} />
				</APIButton>
			</td>
		</tr>
	);
};

export default PhotoGalleryRow;
